import { nextTick, ref } from 'vue';
const SCALE = 16 / 9;
export const useBoxSize = (container) => {
    const boxWidth = ref(0);
    const boxHeight = ref(0);
    nextTick(() => {
        resizeObserve();
    });
    const resizeObserve = () => {
        const dom = container.value;
        const observer = new ResizeObserver(calcContainerScale);
        observer.observe(dom, { box: 'border-box' });
    };
    const calcContainerScale = () => {
        if (!container.value)
            return;
        boxWidth.value = container.value.offsetWidth - 9; // 留出border和视频流之间的距离
        boxHeight.value = container.value.offsetHeight - 9;
    };
    const getContentStyle = () => {
        let contentWidth = 0;
        let contentHeight = 0;
        if (boxWidth.value >= boxHeight.value * SCALE) {
            contentWidth = boxHeight.value * SCALE;
            contentHeight = boxHeight.value;
        }
        else {
            contentWidth = boxWidth.value;
            contentHeight = boxWidth.value / SCALE;
        }
        return {
            width: contentWidth,
            height: contentHeight,
        };
    };
    return { getContentStyle };
};
